module.exports = __webpack_public_path__ + "img/footerReport.efe27051.png";